import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-engin',
  templateUrl: './engin.component.html',
  styleUrls: ['./engin.component.scss']
})
export class EnginComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
